import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 96_1 建築確認番号（三次市）
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot, option) => {

    let ret = []
    
    console.log(spot);

    ret.push(<dl className='dl-list is-modal-spot'><dt>確認済証番号</dt><dd>{spot["確認済証番号"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>座標値（緯度経度）</dt><dd>{spot["座標値(Y)"]},{spot["座標値(X)"]}</dd></dl>)
    
    return ret
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot, option)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
